import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Logo from '../../src/Logo.png';
import "../../src/App.css";
import 'linearicons/dist/web-font/style.css';
import { Navigate, useNavigate } from 'react-router';
import { get, ImageUrl } from '../ApiServices/ApiServices';
import { useDispatch, useSelector } from 'react-redux';
// import { setProfile, clearProfile } from '../features/profile/profileSlice';
import { setProfile } from '../redux/profileSlice';
function Login() {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email address').required('Please Enter Your Email'),
      password: Yup.string().required('Please Enter Your Password'),
    }),
    onSubmit: async (values) => { // Make this function async
      // Disable the button immediately when submitting
      setIsButtonDisabled(true);

      try {
        const response = await axios.post(`${ImageUrl}/admin/api/login`, {
          email: values.email,
          password: values.password
        });

        const token = response.data?.data?.token;
        localStorage.setItem('token', token);

        const api = `view-admin-profile`;
        const totalData = await get(api); // Now this is inside an async function
        console.log(totalData, "totalData")
        dispatch(setProfile(totalData?.data));
        toast.success('Login successful!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          closeButton: false,
        });

        setTimeout(() => {
          navigate("/dashboard");
          formik.resetForm();
          setIsButtonDisabled(false);
        }, 1000);

      } catch (error) {
        console.error('There was an error!', error);

        toast.error('Login failed. Please check your credentials.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          closeButton: false,
        });

        // Re-enable the button after 2 seconds on failure
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 2000);
      }
    },
  });

  // alert("dddd")
  return (
    <div className="nk-app-root">
      <div className="nk-main ">
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content ">
            <div className="nk-block nk-block-middle nk-auth-body  wide-xs">
              <div className="brand-logo pb-4 text-center">
                <a href="" className="logo-link loginLogoSVG">
                  {/* <img className="logo-img logo-img-lg" src="assets/images/suitlogo.png" alt="logo" /> */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="" height="" viewBox="0 0 900 239" version="1.1"><path d="" stroke="none" fill="" fill-rule="evenodd" /><path d="M 150.758 54.925 L 150.500 109.851 114.500 78.953 L 78.500 48.055 39.250 48.027 L 0 48 0 143.500 L 0 239 69.034 239 L 138.068 239 137.784 228.250 L 137.500 217.500 83.250 217.241 L 29 216.983 29 144.991 L 29 73 46.750 73.021 L 64.500 73.042 107.745 107.771 L 150.990 142.500 150.995 190.750 L 151 239 165.500 239 L 180 239 180 119.500 L 180 0 165.508 0 L 151.017 0 150.758 54.925 M 195 119.500 L 195 239 209.500 239 L 224 239 224 207.987 L 224 176.974 260.161 207.987 L 296.323 239 336.161 239 L 376 239 376 143.500 L 376 48 306.967 48 L 237.934 48 238.217 59.013 L 238.500 70.025 292.500 70.263 L 346.500 70.500 346.757 142.750 L 347.013 215 329.257 214.990 L 311.500 214.980 267.750 179.863 L 224 144.746 224 72.373 L 224 0 209.500 0 L 195 0 195 119.500 M 450.750 136.748 L 433 137.046 433 140.956 C 433 145.144, 433.155 145.261, 440.261 146.460 L 444.022 147.095 443.761 187.797 L 443.500 228.500 437.750 229.364 L 432 230.227 432 233.987 L 432 237.746 458.750 238.470 C 482.138 239.103, 486.317 238.983, 492 237.513 C 510.885 232.628, 524.574 219.008, 529.429 200.276 C 531.387 192.719, 531.467 176.343, 529.580 169.256 C 524.813 151.347, 512.817 141.071, 492.555 137.537 C 487.705 136.692, 480.309 136.101, 476.119 136.225 C 471.929 136.349, 460.512 136.585, 450.750 136.748 M 553.750 136.683 L 536 137.046 536 140.944 C 536 144.479, 536.279 144.895, 539 145.421 C 540.650 145.739, 543.350 146.261, 545 146.579 L 548 147.159 548 187.950 L 548 228.742 542 229.420 L 536 230.099 536 233.908 L 536 237.716 561.750 238.430 C 582.804 239.013, 588.800 238.871, 594.626 237.651 C 613.330 233.735, 622.968 223.903, 622.990 208.718 C 622.996 204.988, 622.379 200.449, 621.620 198.632 C 618.791 191.863, 611.341 186.622, 601.514 184.491 C 598.751 183.892, 598.677 183.766, 600.514 182.804 C 606.372 179.737, 610.021 176.380, 612.576 171.708 C 614.937 167.390, 615.426 165.300, 615.434 159.473 C 615.447 150.842, 613.415 146.842, 606.727 142.336 C 598.617 136.871, 589.930 135.944, 553.750 136.683 M 693 140.955 C 693 144.745, 693.155 144.936, 696.750 145.542 C 704.773 146.896, 704 142.373, 704 187.939 L 704 228.742 699 229.406 L 694 230.069 694 234.034 L 694 238 716.500 238 L 739 238 739 234.085 L 739 230.171 731.250 229.526 C 726.987 229.172, 722.825 228.790, 722 228.678 C 720.740 228.507, 720.456 225.546, 720.227 210.189 L 719.955 191.905 730.931 192.068 L 741.908 192.231 743.113 197.615 L 744.318 203 748.659 203 L 753 203 753 187.500 L 753 172 748.659 172 L 744.318 172 743.087 177.500 L 741.857 183 730.928 183 L 720 183 720 164.500 L 720 146 735.494 146 L 750.988 146 753.207 153.545 L 755.427 161.090 760.464 160.795 L 765.500 160.500 765.135 149.500 C 764.935 143.450, 764.571 138.162, 764.326 137.750 C 764.082 137.338, 747.934 137, 728.441 137 L 693 137 693 140.955 M 776.193 141.218 C 776.477 145.127, 776.756 145.496, 780 146.258 L 783.500 147.081 786.781 159.290 C 788.586 166.006, 794.166 186.688, 799.181 205.250 L 808.298 239 814.399 238.993 L 820.500 238.986 828.955 207.532 C 833.606 190.232, 837.573 176.240, 837.771 176.438 C 837.969 176.636, 841.838 190.681, 846.368 207.649 L 854.604 238.500 861.065 238.790 L 867.526 239.081 878.920 196.290 C 885.186 172.756, 890.711 152.050, 891.196 150.278 C 891.918 147.641, 892.798 146.862, 896.039 145.989 C 899.808 144.975, 900 144.730, 900 140.961 L 900 137 885 137 L 870 137 870 140.933 C 870 145.145, 870.151 145.260, 877.250 146.458 C 879.313 146.806, 881 147.532, 881 148.072 C 881 148.612, 877.809 161.754, 873.908 177.277 C 870.008 192.799, 866.036 210, 865.083 215.500 L 863.350 225.500 862.080 218 C 861.071 212.042, 847.555 155.946, 845.402 148.783 C 845.031 147.547, 845.602 146.917, 847.443 146.533 C 848.849 146.240, 851.125 145.766, 852.500 145.481 C 854.661 145.032, 855 144.422, 855 140.981 L 855 137 838.500 137 L 822 137 822 140.961 C 822 144.734, 822.190 144.974, 825.982 145.995 C 829.713 147, 830.068 147.424, 831.613 152.740 L 833.262 158.412 826.481 182.956 C 822.752 196.455, 818.945 211.100, 818.020 215.500 L 816.340 223.500 815.041 216 C 814.326 211.875, 810.249 194.688, 805.979 177.806 L 798.216 147.111 801.358 146.481 C 807.879 145.173, 808 145.071, 808 140.933 L 808 137 791.943 137 L 775.885 137 776.193 141.218 M 461 187.362 L 461 229.724 467.371 230.377 C 475.430 231.202, 487.207 229.562, 492.855 226.828 C 507.389 219.792, 515.153 200.374, 512.215 178.412 C 509.069 154.903, 496.846 145.057, 470.750 145.016 L 461 145 461 187.362 M 565 163 L 565 181 575.250 180.978 C 592.669 180.941, 598.004 176.557, 597.996 162.290 C 597.989 149.217, 592.511 145.059, 575.250 145.022 L 565 145 565 163 M 653.728 164.327 C 644.946 167.059, 638.857 175.257, 638.858 184.350 C 638.858 190.779, 639.977 193.765, 644.174 198.546 C 652.405 207.921, 665.225 208.442, 674.617 199.785 C 683.816 191.306, 684.007 178.912, 675.076 169.981 C 668.722 163.627, 661.839 161.804, 653.728 164.327 M 566.729 190.693 C 565.099 191.118, 564.979 192.689, 565.229 210.327 L 565.500 229.500 575.869 229.786 C 582.892 229.980, 587.901 229.589, 591.390 228.575 C 601.033 225.772, 605.801 218.169, 604.694 207.363 C 603.616 196.843, 598.976 192.590, 586.860 191.017 C 579.278 190.033, 569.847 189.881, 566.729 190.693" stroke="none" fill="" fill-rule=" evenodd" /></svg>

                </a></div>
              <div className="card loginBox">
                <div className="card-inner card-inner-lg">
                  <div className="nk-block-head">
                    <div className="nk-block-head-content">
                      <h4 className="nk-block-title text-center">Login</h4>
                      <div className="nk-block-des text-center">
                        <p>Enter your email address and password to login.</p>
                      </div>
                    </div>
                  </div>
                  <form onSubmit={formik.handleSubmit} className="pt-4">
                    <div className="form-group">
                      <div className="form-control-wrap">
                        <em className="icon ni ni-mail inputIcon"></em>
                        <input
                          id="email" className="form-control form-control-lg pl35"
                          name="email"
                          type="email"
                          placeholder="Enter email address"
                          autoFocus="off"
                          autocomplete="off"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <div className="error">{formik.errors.email}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-control-wrap">
                        <em className="icon ni ni-lock inputIcon"></em>
                        <input
                          id="password" className="form-control form-control-lg pl35"
                          name="password"
                          type="password"
                          placeholder="Enter password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.password}
                        />
                        {formik.touched.password && formik.errors.password ? (
                          <div className="error">{formik.errors.password}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-6 col-md-6">
                        {/* <div className="g"><div className="custom-control custom-control-sm custom-checkbox checked"><input type="checkbox" className="custom-control-input" id="customCheck7" /><label className="custom-control-label" htmlFor="customCheck7">Remember me</label></div>
                        </div> */}
                      </div>
                      <div className="col-6 col-md-6">
                        <a style={{ cursor: "pointer" }} onClick={() => navigate("/forgot-password")} className="forGot">Forgot Password?</a>
                      </div>
                    </div>

                    <div className="form-group">
                      <button className="btn btn-lg btn-primary btn-block btnGradiantLogin" type="submit" disabled={isButtonDisabled} style={{ opacity: isButtonDisabled ? 0.7 : 1, cursor: isButtonDisabled ? 'not-allowed' : 'pointer' }}>{isButtonDisabled ? 'SIGNING IN...' : 'SIGN IN'}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;